import { Link } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useDetectApp } from "lib/monoapp";
import classNames from "classnames";

const AccountSetupLayout = ({ children }) => {
  const isApp = useDetectApp();

  return (
    <div className={classNames("w-full relative", { "h-full": isApp })}>
      <img
        src="https://static.bigbrain.gg/assets/lol/backgrounds/account-setup-bg.png"
        alt="Account Setup Background"
        className="hidden xs:block absolute inset-0 w-full h-screen object-cover z-0"
        style={{ pointerEvents: "none" }}
      />
      {!isApp && (
        <Link className="absolute top-[24px] left-[24px] z-50" to={AppRoutes.HOME}>
          <img className="w-[80px]" src="https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg" alt="U.GG Logo" />
        </Link>
      )}
      <div
        className={classNames(
          "content-side-padding w-full max-w-[400px] mx-auto flex flex-col items-center justify-center max-xs:px-[36px] xs:px-0 relative",
          { "h-full": isApp },
        )}
      >
        <div className={classNames("w-full max-w-[400px] mx-auto relative z-10", { "pt-[100px]": !isApp })}>{children}</div>
      </div>
    </div>
  );
};

export default AccountSetupLayout;
